<loading [isLoading]="isLoadingCanView" [success]="true"></loading>

@if (!isLoadingCanView) {
    @if (canView) {
        <div class="flex flex-col gap-4">
            <div class="font-bold sm:pt-0 text-ponder-light">
                Users
            </div>
            <div class="flex flex-row gap-4 text-sm">
                <div class="flex flex-row gap-1 bg-slate-100 rounded shadow-md p-2 items-center">
                    <div>Username:</div>
                    <input #usernameFilterInput class="p-1 rounded-sm shadow-sm w-[20ch]" value="{{ usernameFilter }}">
                </div>
                <div class="flex flex-row gap-1 bg-slate-100 rounded shadow-md p-2 items-center">
                    <div>Email:</div>
                    <input #emailFilterInput class="p-1 rounded-sm shadow-sm w-[20ch]" value="{{ emailFilter }}">
                </div>
                <button (click)="applyFilter(usernameFilterInput.value, emailFilterInput.value)" class="bg-slate-100 rounded shadow-md p-2 items-center text-slate-900 hover:bg-slate-50 w-[7ch] text-center">
                    Search
                </button>
                @if (usernameFilter || emailFilter) {
                    <button (click)="clearFilters()" class="bg-slate-100 rounded shadow-md p-2 items-center text-slate-900 hover:bg-slate-50 w-[7ch] text-center">
                        Clear
                    </button>
                }
            </div>
            <div class="flex flex-col bg-slate-100 rounded shadow-md h-full">
                <table class="table-auto border-b">
                    <thead>
                        <tr class="text-left bg-ponder-light text-white rounded-t shadow">
                            <th class="w-6 h-6 p-2 rounded-tl"></th>
                            <th class="pt-2 pb-2">Username</th>
                            <th>Email</th>
                            <th>Join Date</th>
                            <th>Role</th>
                            <th></th>
                            <th class="rounded-tr"></th>
                        </tr>
                    </thead>
                    <tbody class="text-sm p-2">
                        <loading [isLoading]="isLoading" [success]="loadingSuccess"></loading>
                        @if (!isLoading && loadingSuccess) {
                            @for (user of users ; track user.user.id) {
                                <tr [ngClass]="{ 'bg-white' : $even, 'bg-slate-50' : $odd }">
                                    <td class="py-2 px-2"><div class="w-6 h-6 sm:w-8 sm:h-8 bg-center bg-no-repeat rounded-full magic-card-shadow" style="background-size: cover; background-image: url('{{ user.user.username! | avatarUrl }}');"></div></td>
                                    @if (!isDeletedUser(user)) {
                                        <td><a href="/user/{{ user.user.username }}" class="text-ponder-link hover:text-ponder-linkhover">{{ user.user.username }}</a></td>
                                    } @else {
                                        <td>{{ user.user.username }}</td>
                                    }
                                    <td>{{ user.user.email }}</td>
                                    <td>{{ user.user.createdAt | date }}</td>
                                    <td>{{ user.role }}</td>
                                    <td>
                                        <button (click)="onEditClicked(user)" class="text-center w-full" [disabled]="!canEdit" [ngClass]="{'cursor-not-allowed text-slate-400' : !canEdit, 'hover:text-ponder-linkhover' : canEdit}">
                                            Edit
                                        </button>
                                    </td>
                                    @if (!isDeletedUser(user)) {
                                        <td>
                                            <button (click)="onDeleteClicked(user)"  class="text-center w-full" [disabled]="!canDelete" [ngClass]="{'cursor-not-allowed text-slate-400' : !canDelete, 'hover:text-ponder-linkhover' : canDelete}">
                                                Delete
                                            </button>
                                        </td>
                                    } @else {
                                        <td>
                                            <button (click)="onUndeleteClicked(user)"  class="text-center w-full" [disabled]="!canDelete" [ngClass]="{'cursor-not-allowed text-slate-400' : !canDelete, 'hover:text-ponder-linkhover' : canDelete}">
                                                Restore
                                            </button>
                                        </td>
                                    }
                                </tr>
                            }
                        }
                    </tbody>
                </table>
                <div class="flex flex-row p-2 pt-1 pb-1 text-xs sm:text-sm bg-slate-100 gap-2 items-center rounded-b">
                    <div class="grow">
                        {{ pageStart }} - {{ pageEnd }} of {{ totalUsers }}
                    </div>
                    <button (click)="onPrevClicked()" class="font-mono bg-slate-100 w-[8ch] sm:w-[10ch] rounded-sm hover:text-ponder-link border border-transparent hover:border-ponder-link hover:bg-slate-50 disabled:border-transparent disabled:text-slate-400 disabled:bg-transparent p-1" [disabled]="(pageStart <= 1)">
                        &lt; Prev
                    </button>
                    <button (click)="onNextClicked()" class="font-mono bg-slate-100 w-[8ch] sm:w-[10ch] rounded-sm hover:text-ponder-link border border-transparent hover:border-ponder-link hover:bg-slate-50 disabled:border-transparent disabled:text-slate-400 disabled:bg-transparent p-1" [disabled]="(pageEnd >= totalUsers)">
                        Next &gt;
                    </button>
                </div>
                <div class="min-h-1 min-w-1"></div>
            </div>
        </div>
    } @else {
        <admin-unauthorized></admin-unauthorized>
    }
    
    <edit-user-dialog></edit-user-dialog>
    <delete-user-dialog></delete-user-dialog>
    <undelete-user-dialog></undelete-user-dialog>
}